// Reuse organization types and service since they're identical
import OrganizationService from "./organization";
export default class CustomersService extends OrganizationService {
    async getAllCustomers() {
        return this.getAllOrganizations();
    }
}
